// extracted by mini-css-extract-plugin
export default {"writer":"Writer_writer__ec1HJ"};